export default __webpack_public_path__ + "static/media/Evrima_LOGO_High.94bb346b.png";